(function(algolia) {
  'use strict';
  const render = algolia.externals.render;
  const html = algolia.externals.html;

  var algoliasearch = algolia.externals.algoliasearch;
  algolia.searchClient = algoliasearch(
          algolia.config.app_id,
          algolia.config.search_api_key
  );

  algolia.render = (template, container, data) => {
    return render(template(html, data), container);
  };

  var algoliasearch = algolia.externals.algoliasearch;
  algolia.searchClient = algoliasearch(
          algolia.config.app_id,
          algolia.config.search_api_key
  );

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(val) {
      return Number(val).toLocaleString();
    },
    displayPrice: function displayPrice(item, distinct) {
      if (distinct) {
        var min = item.variants_min_price;
        var max = item.variants_max_price;
        if (min !== max) {
          return  "From: " + formatPrice(algolia.helpers.calculateDiscountedPrice(min, item.tags));
        }
      }
      return formatPrice(algolia.helpers.calculateDiscountedPrice(item.price, item.tags));
    },
    calculateDiscountedPrice: function calculateDiscountedPrice(val, tags) {
      var rawprice = val/100;
      var variantprice = val;      
      var maxDiscount = 0;
      var isNetDiscount = 0;
      var price = 0;

      //PD-247: No discout for platform-pro customers
      var applyCustomDiscount = true;

      if(searchCustomerTags.includes("platform-pro") > 0) {
        if(searchCustomerTags.includes("enterprise") > 0) {
          var applyCustomDiscount = true;
        } else {
          var applyCustomDiscount = false;
        }
      }
      
      if(applyCustomDiscount == true) {
        // First check if platform account level discount is applied
        tags.forEach(function(ptag) {
          if(ptag.includes("*net-")) {
            //var custTags = searchCustomerTags.toString();
            var custTags = searchCustomerTags;
            
            if(ptag.includes("tier-")) {
            } else {
              if(custTags.includes("millerknoll") && ptag.includes("enterprise")) {
              } else {
                isNetDiscount = 1;
      
                var disTagsToCheck = "";
                var disTags = ptag.split("_");
                
                if(disTags.length > 2) {
                  disTagsToCheck = disTags[1].concat("_", disTags[2]);
                } else {
                  disTagsToCheck = disTags[1];
                }
    
                if(custTags.includes(disTagsToCheck)) {
                  var disValue = disTags[0].split("-");
                  var disPercentage = parseFloat(disValue[1]) * 0.01;
                  if(disPercentage > maxDiscount) {
                    maxDiscount = disPercentage;
                  }
                }
              }
            }
          }
        });
  
        if(maxDiscount == 0) {
          tags.forEach(function(ptag) {
            if(ptag.includes("*net-")) {
    
              //var custTags = searchCustomerTags.toString();
              var custTags = searchCustomerTags;
              
              if(custTags.includes("millerknoll") && ptag.includes("enterprise")) {
              } else {
                
                isNetDiscount = 1;
      
                var disTagsToCheck = "";
                var disTags = ptag.split("_");
                
                if(disTags.length > 2) {
                  disTagsToCheck = disTags[1].concat("_", disTags[2]);
                } else {
                  disTagsToCheck = disTags[1];
                }
    
                if(custTags.includes(disTagsToCheck)) {
                  var disValue = disTags[0].split("-");
                  var disPercentage = parseFloat(disValue[1]) * 0.01;
                  if(disPercentage > maxDiscount) {
                    maxDiscount = disPercentage;
                  }
                } 
              }
            }
          });
        }
  
        if(maxDiscount != 0) {
          var disAmount = rawprice * maxDiscount;
          var disPrice = rawprice - disAmount;
          price = disPrice * 100;
        }
      }

      return price == 0 ? val : price;
    },
    displayStrikedPrice: function displayStrikedPrice(discountedPrice, variant_min_price) {
      var custTags = searchCustomerTags;
      //if(custTags.includes("tradeprogram")) {
        if(discountedPrice != variant_min_price) {
          return formatPrice(variant_min_price);
        } else { return ''; }
      /*} else {
        return '';
      }
      /*const comparing =
        Number(variant_min_price) && Number(variant_min_price) > Number(discountedPrice);
      if (comparing) { return formatPrice(variant_min_price) }*/      
    },
    displayDiscount: function displayDiscount(discountedPrice, variant_price, price_ratio) {
      /*const comparing = Number(compare_at_price) && Number(compare_at_price) > Number(price);
      const discount_ratio = 1.0 - price_ratio;
      if (comparing) { return `${Math.round(discount_ratio * 100)} % Off`}*/

      var custTags = searchCustomerTags;
      if(custTags.includes("tradeprogram")) {
        const comparing = Number(variant_price) && Number(variant_price) > Number(discountedPrice);
        const discount_ratio = (variant_price-discountedPrice)/variant_price;
        if (comparing) { return `${Math.round(discount_ratio * 100)} % Off`} else { return ''; }
      } else {
        return '';
      }    
    },
    instantsearchLink: function instantsearchLink(hit) {
      if(hit._qsDistinct === false) {
        return (
          '/products/' +
          hit.handle + '?variant=' + hit.objectID);
      } else {
        const addVariantId = !hit._distinct && hit.objectID !== hit.id;
        
        return (
          '/products/' +
          hit.handle +
          (addVariantId ? '?variant=' + hit.objectID : '')
        );
      }
    },
    
    fullTitle: function fullTitle(title, distinct, variant_title) {
      var res = title;
      if (
        !distinct &&
        variant_title &&
        variant_title !== 'Default Title' &&
        variant_title !== 'Default'
      ) {
        res += ' (' + variant_title + ')';
      }

      return escapeHtml(res);
    },
    variantTitleAddition: function variantTitleAddition(item, distinct) {
      var res = ' ';
      if (
        !distinct &&
        item.variant_title &&
        item.variant_title !== 'Default Title' &&
        item.variant_title !== 'Default'
      ) {
        res += `( ${item.variant_title} )`;
      }
      return res;
    },
    hexToRGB: function hexToRGB(hex){
      if (!hex) return ``;
      if(hex.length== 4){
        hex = hex.substring(1).replace(/./g, '$&$&')
      }
      var m = hex.match(/^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i);
      return `${parseInt(m[1], 16)},${parseInt(m[2], 16)},${parseInt(m[3], 16)}`;
    },
    sizedImage: function sizedImage(sizeInput, item, _distinct) {
      var image = _distinct ? item.product_image : item.image;
      //console.log('image', image);
      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }
      var size = sizeInput.replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    }
  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original'
  ].forEach(function(size) {
    algolia.helpers[size + 'Image'] = function(item) {
        //var image = item.distinct ? item.product_image : item.image;
        /*var image = item.image ? item.image : item.product_image;
        if(item.vendor === 'Wendelbo' || item.vendor === 'Kenneth Cobonpue' || item.vendor === 'Artifort' || item.vendor === 'Sancal') {
          image = item.product_image;
        }*/

        var image = item.product_image;

        if (!image) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }

        if (size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    };
  });
})(window.algoliaShopify);
